<form [formGroup]="form">
    <mlp-ng-select
        formControlName="city"
        [options]="options"
        class="mb-2 d-block"
    ></mlp-ng-select>
    <a class="sg-btn d-block cursor pointer" (click)="submitted()">Go</a>
</form>
